import React from 'react';
import { useSelector } from 'react-redux';
import { App } from '@gin-betting/core';

import { selectOddFormat } from '../../selectors';

interface Props {
    children: (oddFormat: App.OddFormat) => JSX.Element;
}

const OddFormat: React.FC<Props> = ({ children }) => {
    const oddFormat = useSelector(selectOddFormat);

    return children(oddFormat);
};

export default OddFormat;
